import React, { useEffect } from 'react';
import type DraggableItem from '../DraggableItem';
import { type ItemComponentProps } from './types';
import CardDragLayer from './CardDragLayer';
import { sharedDragController } from '../controllers/DragController';

type CardDragRegistryProps<
  ItemClass extends {
    new (...args: any[]): DraggableItem;
  }
> = {
  DraggableItemClass: ItemClass;
  CardComponent: React.FC<ItemComponentProps<any>>;
};

const CardDragRegistry: React.FC<CardDragRegistryProps<any>> = ({
  DraggableItemClass,
  CardComponent,
}) => {
  useEffect(() => {
    const unregister = sharedDragController.registerDragComponent(
      DraggableItemClass,
      CardComponent
    );
    return () => {
      unregister();
    };
  }, [DraggableItemClass, CardComponent]);

  return (
    <CardDragLayer CardWrapper={CardComponent} type={DraggableItemClass.name} />
  );
};

export default CardDragRegistry;
